import styled from '@emotion/styled';

export const PublicPageHeader = styled.header`
    margin-top: 24px;
    margin-bottom: 48px;
`;
